import { MakeCall } from 'ha/services/apiV2/createMakeCall';
// eslint-disable-next-line sort-imports
import { APIV2_URL } from './constants';

interface ListingVideoResource {
  id: number;
  url: string;
  name: string;
  fileSize: number;
  length: number;
  title: string;
  author: string;
}

type Order = number;

export type Videos = ListingVideoResource[];

export default (makeCall: MakeCall) => (listingId: number, order: Order[]) =>
  makeCall<Videos>('PUT', `${APIV2_URL}/listing/${listingId}/videos`, {
    data: order,
  });
